<template>
<div class="main">

	<div class="column login">

		<h1>Forgot Password</h1>

		<template v-if="showForgotPasswordControls">
			<label>What's your email address?</label>
            <input type="text" v-model="username" ref="username">
			<div v-if="showResetButton" class="v-spaced">
    			<button :class="['button', loading ? 'disabled' : 'action']" @click.stop.prevent="doConfirmUsername()">Confirm Email</button>
            </div>
			<p v-if="message" class="v-spaced">{{ message }}</p>
			<div v-if="!loading" class="forgot">
				<div class="back" @click="backToLogin">Cancel forgot password and return to login...</div>
			</div>
		</template>

        <template v-if="showForgotPasswordControlsB">
			<p>Next we'll send you a new temporary password with instructions for logging in again.</p>
			<div v-if="showResetButton" class="v-spaced">
    			<button class="button action" @click.stop.prevent="doPasswordReset()">Send Temporary Password</button>
            </div>
			<div v-if="message" class="message v-spaced" >{{ message }}</div>
			<div v-if="!loading" class="forgot">
				<div class="back" @click="backToLogin">Cancel forgot password and return to login...</div>
			</div>
		</template>

		<template v-if="showTemporaryPasswordControls">
			<p>Check your email for your new temporary password and enter it below...</p>
			<label>Temporary Password:</label>
			<input type="password" v-model="temporaryPassword" ref="temporaryPassword" @keyup.enter="validateTemporaryPassword()">
            <div class="v-spaced">
    			<button :class="['button', loading ? 'disabled' : 'action']" @click.stop.prevent="validateTemporaryPassword()">Validate Temporary Password</button>
            </div>
			<div v-if="message" class="message" >{{ message }}</div>
		</template>

		<template v-if="showResetPassword">
			<p>Temporary password validated! Enter your new password below...</p>
			<label class="label">Enter a New Password:</label>
			<input type="password" v-model="password">
            <label class="label">Retype New Password:</label>
			<input type="password" v-model="retype_password">
			<div class="v-spaced">
    			<button :class="['button', loading ? 'disabled' : 'action']" @click="doSetNewPassword()">Reset Password</button>
            </div>
			<div v-if="message" class="message" >{{ message }}</div>
		</template>

		<template v-if="resetPasswordSuccess">
			<p class="v-spaced">Your password has been reset!<br>Sign In to proceed.</p>
			<div class="v-spaced">
				<button :class="['button', loading ? 'disabled' : 'action']" @click="backToLogin()">Sign In</button>
			</div>
			<div v-if="message" class="message" >{{ message }}</div>
		</template>

    	<loading v-if="loading"></loading>

	</div>

</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			loading: false,
			username: '',
            token: '',
			temporaryPassword: '',
    		password: '',
    		retype_password: '',
			temporaryPasswordSent: false,
            showResetButton: true,
			showForgotPasswordControls: true,
            showForgotPasswordControlsB: false,
			showTemporaryPasswordControls: false,
    		showResetPassword: false,
    		resetPasswordSuccess: false,
    		message: '',
		}
	},

	created() {
        if (this.$route.query.token && this.$route.query.username) {
            this.token = this.$route.query.token
            this.username = this.$route.query.username
            this.showForgotPasswordControls = false
            this.showForgotPasswordControlsB = true
        }
	},
	mounted() {
		this.returnTo = (this.$route.query.return) ? decodeURI(this.$route.query.return) : ''
		if (this.$route.query.logout) {
			this.doLogout()
		}
		if (this.$route.query.code == 'expired') {
			this.sessionExpired = true
		}
	},
	methods: {
        doConfirmUsername() {
            if (!this.username) return
            if (this.loading) { return }
            this.message = 'Confirming email address...'
            this.loading = true
            this.apiCall({ destination: 'forgot_password_check_username', data: { user_name: this.username }}).then(obj => {
                this.loading = false
                this.message = obj.message
                if (obj.status == 'success') {
                    this.showResetButton = false
                }
            })
        },
    	doPasswordReset() {
	    	if (!this.username) return
            if (this.loading) { return }
		    this.message = 'Sending temporary password...'
			this.loading = true
    		this.apiCall({ destination: 'forgot_password', data: { user_name: this.username, token: this.token }}).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
        		    this.message = ''
					this.showForgotPasswordControls = false
                    this.showForgotPasswordControlsB = false
					this.showTemporaryPasswordControls = true
    			} else {
					this.message = obj.message
				}
    		})
	    },
		validateTemporaryPassword() {
			if (this.loading) { return }
		    this.message = ''
			this.loading = true
    		this.apiCall({ destination: 'validate_temporary_password', data: { user_name: this.username, password: this.temporaryPassword }}).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					this.showForgotPasswordControls = false
					this.showTemporaryPasswordControls = false
					this.showResetPassword = true
    			} else {
					this.message = obj.message
				}
    		})
		},
	    doSetNewPassword() {
			if (this.loading) { return }
		    this.message = ''
    		if (!this.retype_password || !this.password) return
    		if (this.retype_password != this.password) {
	    		this.message = 'Passwords do not match'
	    		return
	    	}
			this.loading = true
    		this.apiCall({ destination: 'reset_password', data: { user_name: this.username, password: this.password, token: this.token }}).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					this.showResetPassword = false
					this.resetPasswordSuccess = true
    			} else {
	    			this.message = obj.message
    			}
    		})
		},
		backToLogin() {
			this.$router.push('/login')
		},
	}
}
</script>
<style lang="scss" scoped>
.columns {
	grid-gap: 1em 4rem;
	.column {
		display: grid;
		grid-auto-flow: row dense;
		input {
			width: auto;
		}
		.button, .controls.button {
			display: grid;
			align-items: center;
			margin: 1em 0;
		}
	}
}
.back {
	cursor: pointer;
	width: max-content;
	font-size: 0.8rem;
}
.main:not(.sections) {
 background-color: transparent;
 color: black;
}
</style>